import React from 'react';
import { Drawer } from 'syngenta-digital-cropwise-react-ui-kit';
import { FullProduct } from 'screens/Applications&WorkOrders/Applications/Hooks/useApplication';
import Header from './components/Header';
import Content from './components/Content';
import Footer from './components/Footer';
import './index.css';

interface ProductViewMoreDetailsDrawerProps {
  open: boolean;
  onClose: () => void;
  product: FullProduct | null;
  hasTankInformation: boolean;
}

const ProductViewMoreDetailsDrawer = ({
  open,
  onClose,
  product,
  hasTankInformation
}: ProductViewMoreDetailsDrawerProps) => {
  return (
    <Drawer
      placement="right"
      className="product-view-more-details-drawer"
      open={open}
      onClose={onClose}
      closable={false}
      maskClosable
      width={424}
      footer={<Footer onClose={onClose} />}
    >
      {product && (
        <div className="h-full px-8">
          <Header product={product} onClose={onClose} />
          <Content product={product} hasTankInformation={hasTankInformation} />
        </div>
      )}
    </Drawer>
  );
};

export default ProductViewMoreDetailsDrawer;
